import { createContext, useContext } from 'react';

export interface ImageLightboxContextType {
    openLightbox: (imageUrl: string | null | undefined) => void;
    closeLightbox: () => void;
    imageUrl: string | null | undefined;
    isOpen: boolean;
}

export const ImageLightboxContext = createContext<
    ImageLightboxContextType | undefined
>(undefined);

export const useImageLightbox = (): ImageLightboxContextType => {
    const context = useContext(ImageLightboxContext);
    if (!context) {
        throw new Error(
            'useImageLightbox must be used within an ImageLightboxProvider',
        );
    }
    return context;
};
